export const islandComponents = {}